<template>
 <el-container class="count-container">
   <el-main>
     <el-scrollbar ref="contentScrollbar" class="default-scrollbar content-bg contentScroll"
                   wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
       <div  class="count-main">
         <div v-if="hasPermission('per_count_002')" class="count-wrap" ref="count0">
           <!-- 经营情况 -->
           <count-manage :orgs="orgs"></count-manage>
         </div>
         <div v-if="hasPermission('per_count_003')" class="count-wrap" ref="count1">
           <!-- 门诊趋势 -->
           <count-record-outpatient-trend :orgs="orgSortList"></count-record-outpatient-trend>
         </div>
         <div v-if="hasPermission('per_count_004')" class="count-wrap" ref="count2">
           <!-- 住院趋势 -->
           <count-record-inpatient-trend :orgs="orgSortList"></count-record-inpatient-trend>
         </div>
         <div class="count-wrap" ref="count3">
           <!-- 麻醉统计 -->
           <count-anaesthesia></count-anaesthesia>
         </div>
         <div v-if="hasPermission('per_count_005')" class="count-wrap" ref="count4">
           <!-- 手术统计 -->
           <count-operation :orgs="orgs"></count-operation>
         </div>
         <div v-if="hasPermission('per_count_006')" class="count-wrap" ref="count5">
           <!-- 手术趋势 -->
           <count-operation-trend :orgs="orgSortList"></count-operation-trend>
         </div>
         <div v-if="hasPermission('per_count_007')" class="count-wrap" ref="count6">
           <!-- 营收统计 -->
           <count-revenue :orgs="orgs"></count-revenue>
         </div>
         <div v-if="hasPermission('per_count_008')" class="count-wrap" ref="count7">
           <!-- 营收趋势 -->
           <count-revenue-trend :orgs="orgSortList"></count-revenue-trend>
         </div>
         <div v-if="hasPermission('per_count_009')" class="count-wrap" ref="count8">
           <!-- 随访统计 -->
           <count-followup :orgs="orgs"></count-followup>
         </div>
         <div v-if="hasPermission('per_count_0010')" class="count-wrap" ref="count9">
           <!-- 地域统计-->
           <count-position :orgs="orgSortList"></count-position>
         </div>
         <div v-if="hasPermission('per_count_0011')" class="count-wrap" ref="count10">
           <!-- 地域趋势-->
           <count-postition-trend :orgs="orgSortList"></count-postition-trend>
         </div>
         <div class="count-wrap" ref="count11">
           <!-- 个人工作量 -->
           <count-workload :orgs="orgSortList"></count-workload>
         </div>
       </div>
     </el-scrollbar>
     <ul class="ul-warp">
       <li :class="i === step ? 'active' : ''" v-for="(type, i) of countTypeList" :key="i"  @click="scrollTo(i)">
         <a class="clearA" href="javascript:void(0);">{{type}}</a>
       </li>
     </ul>
   </el-main>
 </el-container>
</template>
<script>
import OrgService from '@/request/user/org'
import _ from 'lodash'
// import store from '../store'
import { scrollTop } from '@/utils/assist'
import PermissionUtils from '@/utils/permission'
import CountWorkload from "../../../components/EberModules/packages/count/src/count-workload";
export default {
  name: "Dashboard",
  components: {CountWorkload},
  data() {
    return {
      step: 0,
      countTypeList: ['经营情况', '门诊趋势', '住院趋势', '麻醉统计', '手术统计', '手术趋势', '营收统计', '营收趋势', '随访统计', '地域统计', '地域趋势', '工作量统计'],
      orgs: [],
      orgSortList: [],
      hosTreeList: [],
      scrollTop: null,
      sum: 0
    }
  },
  created() {
    this.listOrg()
    // console.log(store.state);
  },
  mounted() {
    const that = this;
    this.$nextTick(() => {
      that.$refs.contentScrollbar.wrap.onscroll = () => {
        that.watchScroll();
      };
    })
  },
  methods: {
    listOrg() {
      OrgService.listOrg({parents: 1, descendant: 1, typeSns: 'lx0001,lx0001001,lx0001001001,lx0001001004'}).then(res => {
        // const _orgs = [];
        this.orgs = _.clone(res.result); // 所有组织
        // _.forEach(_.clone(res.result), val => {
        //   if (val.typeId === 2 || val.typeId === 3) {
        //     _orgs.push(val);
        //   }
        // });
        const _orgSortList = this.toTree(_.clone(res.result) || []) // 所有组织的组织树
        if (_orgSortList.length === 1) {
          this.orgSortList = _orgSortList[0].children
        } else {
          this.orgSortList = _orgSortList
        }
      })
    },
    hasPermission (sns) {
      return PermissionUtils.hasPermission(sns, this.$store.getters.permissions, false)
    },
    scrollTo (index) {
      if (!this.$refs.contentScrollbar || !this.$refs.contentScrollbar.wrap) {
        return
      }
      this.sum = 0;
      this.step = index;
      let from = this.$refs.contentScrollbar.wrap.scrollTop;
      let to = 0;
      let target = index ? this.$refs[`count${index}`] : null;
      if (_.isArray(target)) {
        target = target[0]
      }
      if (!target) {
        to = 0
      } else {
        to = target.offsetTop
      }
      scrollTop(this.$refs.contentScrollbar.wrap, from, to, 1000)
    },
    toTree(list){
      let result = [], temp = {}, i = 0, j = 0, len = list.length;
      for(; i < len; i++){
        temp[list[i]['id']] = list[i]; // 以id作为索引存储元素，可以无需遍历直接定位元素
      }
      for(; j < len; j++){
        var currentElement = list[j];
        var tempCurrentElementParent = temp[currentElement['pid']]; // 临时变量里面的当前元素的父元素
        if (tempCurrentElementParent) { // 如果存在父元素
          if (!tempCurrentElementParent['children']) { // 如果父元素没有chindren键
            tempCurrentElementParent['children'] = [] // 设上父元素的children键
            tempCurrentElementParent['childrenIds'] = []
          }
          tempCurrentElementParent['childrenIds'].push(currentElement.id);
          tempCurrentElementParent['children'].push(currentElement) // 给父元素加上当前元素作为子元素
        } else if (currentElement.typeId !== 3) { // 不存在父元素，意味着当前元素是一级元素
          result.push(currentElement);
        }
      }
      return result
    },
    watchScroll() {
      let scrollTop = this.$refs.contentScrollbar.wrap.scrollTop;
      this.sum++;
      const stepHeightList = [];
      let height = 0;
      for (let i = 0; i < 10; i++) {
        height = this.$refs[`count${i}`].offsetHeight + height;
        stepHeightList.push(height)
      }
      if (this.sum > 20) {
        if (scrollTop >= 0 && scrollTop < stepHeightList[0]) {
          this.step = 0
        }
        if (scrollTop >= stepHeightList[0] && scrollTop < stepHeightList[1]) {
          this.step = 1
        }
        if (scrollTop >= stepHeightList[1] && scrollTop < stepHeightList[2]) {
          this.step = 2
        }
        if (scrollTop >= stepHeightList[2] && scrollTop < stepHeightList[3]) {
          this.step = 3
        }
        if (scrollTop >= stepHeightList[3] && scrollTop < stepHeightList[4]) {
          this.step = 4
        }
        if (scrollTop >= stepHeightList[4] && scrollTop < stepHeightList[5]) {
          this.step = 5
        }
        if (scrollTop >= stepHeightList[5] && scrollTop < stepHeightList[6]) {
          this.step = 6
        }
        if (scrollTop >= stepHeightList[6] && scrollTop < stepHeightList[7]) {
          this.step = 7
        }
        if (scrollTop >= stepHeightList[7] && scrollTop < stepHeightList[8]) {
          this.step = 8
        }
        if (scrollTop >= stepHeightList[8] && scrollTop < stepHeightList[9]) {
          this.step = 9
        }
        if (scrollTop >= stepHeightList[9] && scrollTop < stepHeightList[10]) {
          this.step = 10
        }
        if (scrollTop >= stepHeightList[10]) {
          this.step = 11
        }
      }
    }
  }
}
</script>

<style scoped>
  .count-container {
    background-color: #f2f6fc;
  }
  .count-main {
    padding: 10px 140px 30px 140px;
  }
  .count-wrap {
    padding: 0 40px 30px 40px;
    margin-top: 30px;
    background-color: #fff;
  }
  .ul-warp {
    position: fixed;
    list-style: none;
    width: 95px;
    top: 100px;
    right: 1.5%;
    line-height: 48px;
  }
  .ul-warp li {
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: white;
  }
  .ul-warp .active {
    background-color: #1890ff;
    color: white;
  }
  .active .clearA {
    color: white;
  }
  .clearA {
    text-decoration:none;
    color: #000000;
  }
</style>
